import * as ActionTypes from '../ActionTypes';

const initialState = {
    leavingreasonData: [],
    isLoading: false,
};

const LeavingReasonReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.LEAVING_REASON_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                leavingreasonData: "",
            };
        case ActionTypes.LEAVING_REASON_GET_SUCCESS:
            return {
                ...state,
                success_message: action.payload.message,
                error: action.payload.has_error,
                isLoading: false,
                leavingreasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVING_REASON_ADD_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.LEAVING_REASON_ADD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavingreasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVING_REASON_ADD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.LEAVING_REASON_UPDATE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.LEAVING_REASON_UPDATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavingreasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVING_REASON_UPDATE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        case ActionTypes.LEAVING_REASON_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
            };
        case ActionTypes.LEAVING_REASON_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                leavingreasonData: action.payload?.data?.data
            };
        case ActionTypes.LEAVING_REASON_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action?.payload?.hasError,
                errorMessage: action.payload?.data?.error?.[0]?.message
            };
        default:
            return state;
    }
}

export default LeavingReasonReducer;